import React from "react";

class Nbsp extends React.Component {
    render() {
        return (
            <span>{String.fromCharCode(160)}</span>
        );
    }
}

export default Nbsp;
